module.exports = __webpack_public_path__ + "static/img/nodata.fa342acc.png";